import {ConfigObjectType, locationContainer} from '@wallaby-ui/core';
import {isEmpty} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {useEffect} from 'react';
import {connect, ConnectedProps} from 'react-redux';

import {FilterBox} from './FilterBox';
import {getNotEmptySelectedFilters} from '../filtering_selectors';
import {
  getCaseType,
  getServiceUrls,
} from 'src/js/containers/filter_and_search/filter_and_search_selectors';
import {
  saveUserFilter,
  loadFiltersConfig,
  loadStateFromParams,
  loadStateFromParamsWithDefaultValues,
} from 'src/js/containers/filtering/filtering_actions';
import {RootState} from 'src/js/store';

interface OwnProps {
  config: ConfigObjectType;
  filteringStateId: string;
  filterAndSearchStateId: string;
  serviceUrls: Record<string, any>;
}

const mapState = (state: RootState, props: OwnProps) => ({
  filtersConfig: state[props.filteringStateId].filtersConfig,
  locationState: state[props.filteringStateId].locationState,
  schema: state[props.filteringStateId].schema,
  caseType: getCaseType(state, props),
  selectedFilters: getNotEmptySelectedFilters(state, props),
  serviceUrlsBySelector: getServiceUrls(state, props),
});

const mapDispatch = {
  changeParams: locationContainer.changeParams,
  loadFiltersConfigAC: loadFiltersConfig,
  loadStateFromParamsAC: loadStateFromParams,
  loadStateFromParamsWithDefaultValuesAC: loadStateFromParamsWithDefaultValues,
  saveUserFilterAC: saveUserFilter,
};

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & OwnProps;

const FilteringContainerComponent: React.FC<Props> = (props) => {
  const {
    config,
    filterAndSearchStateId,
    filteringStateId,
    filtersConfig,
    serviceUrlsBySelector,
    caseType,
    schema,
    selectedFilters,
    locationState,
    loadFiltersConfigAC,
    loadStateFromParamsAC,
    loadStateFromParamsWithDefaultValuesAC,
    saveUserFilterAC,
  } = props;

  useEffect(() => {
    if (isEmpty(filtersConfig) || !filtersConfig.isLoaded()) {
      // TODO-JK: refactor configContainer is removed
      loadFiltersConfigAC(
        filteringStateId,
        serviceUrlsBySelector.filtersConfigPath,
        'CONFIG_STATE_ID',
        config.service.url.range,
        config.service.url.configDataSet,
        config.service.url.userFilters,
        serviceUrlsBySelector.userFilterType,
        filterAndSearchStateId
      );
    } else {
      loadStateFromParamsWithDefaultValuesAC(
        filteringStateId,
        filterAndSearchStateId,
        serviceUrlsBySelector.userFilterType
      );
    }
  }, [
    config.service.url.configDataSet,
    config.service.url.range,
    config.service.url.userFilters,
    filterAndSearchStateId,
    filteringStateId,
    filtersConfig,
    loadFiltersConfigAC,
    loadStateFromParamsWithDefaultValuesAC,
    serviceUrlsBySelector.filtersConfigPath,
    serviceUrlsBySelector.userFilterType,
  ]);

  useEffect(() => {
    if (locationState.reload) {
      if (filtersConfig.isLoaded()) {
        // we have to load default values if we access filtering container through formatter link
        loadStateFromParamsWithDefaultValuesAC(
          filteringStateId,
          filterAndSearchStateId,
          serviceUrlsBySelector.userFilterType
        );
      } else {
        loadStateFromParamsAC(filteringStateId, filterAndSearchStateId);
      }
    }
  }, [
    filterAndSearchStateId,
    filteringStateId,
    filtersConfig,
    loadStateFromParamsAC,
    loadStateFromParamsWithDefaultValuesAC,
    locationState.reload,
    serviceUrlsBySelector.userFilterType,
  ]);

  // componentDidUpdate(prevProps) {
  //   const {
  //     filtersConfig,
  //     filterAndSearchStateId,
  //     filteringStateId,
  //     locationState,
  //     serviceUrlsBySelector,
  //   } = this.props;
  //   if (
  //     locationState.reload &&
  //     prevProps.locationState.reload !== locationState.reload
  //   ) {
  //     if (filtersConfig.isLoaded()) {
  //       // we have to load default values if we access filtering container through formatter link
  //       this.props.loadStateFromParamsWithDefaultValues(
  //         filteringStateId,
  //         filterAndSearchStateId,
  //         serviceUrlsBySelector.userFilterType
  //       );
  //     } else {
  //       this.props.loadStateFromParams(
  //         filteringStateId,
  //         filterAndSearchStateId
  //       );
  //     }
  //   }
  // }

  const saveFilter = (filterName: any) => {
    saveUserFilterAC(
      filteringStateId,
      config.service.url.userFilters,
      serviceUrlsBySelector.userFilterType,
      filterName
    );
  };

  return (
    <FilterBox
      caseType={caseType}
      config={config}
      filteringStateId={filteringStateId}
      filterAndSearchStateId={filterAndSearchStateId}
      saveFilter={saveFilter}
      selectedFilters={selectedFilters}
      schema={schema}
      serviceUrls={serviceUrlsBySelector}
    />
  );
};

FilteringContainerComponent.displayName = 'FilteringContainer';

export const FilteringContainer = connector(FilteringContainerComponent);
